module.exports = __webpack_public_path__ + "static/media/ptor-landing-page-bg.9e5122f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ptor-landing-page-bg.jpg
// module id = 945
// module chunks = 0